import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { createClient, NewClientPayload } from "../../services/dashboard/NewClient";
import "../../styles/dash/CreateOrEditChatBot.css"; // Reusing styles
import LoadingSpinner from "../utility/LoadingSpinner";

interface Props {
    show: boolean;
    onClose: () => void;
    onSuccess: () => void; // To refresh the client list
}

const CreateClientModal: React.FC<Props> = ({ show, onClose, onSuccess }) => {
    const [nombre, setNombre] = useState("");
    const [email, setEmail] = useState("");
    const [telefono, setTelefono] = useState("");
    const [status, setStatus] = useState(true);

    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [animateOut, setAnimateOut] = useState(false);

    const handleClose = () => {
        setAnimateOut(true);
        setTimeout(() => {
            onClose();
            setAnimateOut(false);
            // Reset form
            setNombre("");
            setEmail("");
            setTelefono("");
            setStatus(true);
            setErrorMessage("");
        }, 300);
    };

    const handleSubmit = async () => {
        // Validations
        if (!nombre.trim() || !email.trim() || !telefono.trim()) {
            setErrorMessage("Todos los campos son obligatorios.");
            return;
        }

        setLoading(true);
        setErrorMessage("");

        try {
            const payload: NewClientPayload = {
                Nombre: nombre,
                Email: email,
                Telefono: telefono,
                Status: status ? 1 : 0,
            };

            await createClient(payload);
            onSuccess();
            handleClose();

        } catch (error: any) {
            setErrorMessage(error.message || "Ocurrió un error al crear el cliente.");
        } finally {
            setLoading(false);
        }
    };

    if (!show && !animateOut) return null;

    return (
        <Modal
            show={!animateOut}
            onHide={handleClose}
            centered
            size="lg"
            backdrop="static"
            contentClassName={`chatbot-form-modal ${animateOut ? 'modal-exit' : 'modal-enter'}`}
        >
            <Modal.Header closeButton closeVariant="white" className="border-0" />

            <Modal.Body className="chatbot-form-content">
                <h5 className="form-title text-center mb-4">
                    Crear Nuevo Cliente
                </h5>

                <Form>
                    {loading && <LoadingSpinner />}
                    <div className="form-grid">
                        <div className="form-group">
                            <label>Nombre</label>
                            <input
                                type="text"
                                value={nombre}
                                onChange={(e) => setNombre(e.target.value)}
                                placeholder="Ej: Empresa S.A."
                            />
                        </div>

                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Ej: contacto@empresa.com"
                            />
                        </div>

                        <div className="form-group">
                            <label>Teléfono</label>
                            <input
                                type="text"
                                value={telefono}
                                onChange={(e) => setTelefono(e.target.value)}
                                placeholder="Ej: +123456789"
                            />
                        </div>

                        <div className="form-group switch-group">
                            <label>¿Activo?</label>
                            <label className="switch">
                                <input
                                    type="checkbox"
                                    checked={status}
                                    onChange={() => setStatus(!status)}
                                />
                                <span className="slider round"></span>
                            </label>
                        </div>

                        <div className="form-group full-width">
                            {errorMessage && (
                                <div className="error-message">
                                    {errorMessage}
                                </div>
                            )}

                            <button
                                type="button"
                                className="save-button"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? "CREANDO..." : "CREAR CLIENTE"}
                            </button>
                        </div>

                        <div className="form-group full-width text-center">
                            <button
                                type="button"
                                className="cancel-button"
                                onClick={handleClose}
                                disabled={loading}
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default CreateClientModal;

